import { createStyles, rem } from '@mantine/styles';

export default createStyles({
  // required to allow dropdown padding override with styles and classNames
  dropdown: { padding: rem(4) },
});
